<template>
	<div class="container-fluid">
		<library-toolbar heading="Library" heading-icon="fa-book">
			<button v-if="userCanWrite" class="btn btn-success" v-on:click="uploadFile">
				<i class="fa fa-upload"></i>
				Upload a File
			</button>
		</library-toolbar>

		<collapsible-panel :always-open="true" panel-size="sm">
			<template slot="panel">

				<h3>Filter By Tag</h3>

				<!--<panel-menu :menu-items="tagMenu" class="mb-2"
					:active-item="tagFilter"
					v-on:itemClick="navigateToTag">
				</panel-menu>-->

				<div v-for="tag in tags">
					<label class="tag-label">
						<input type="checkbox" :value="tag.friendly_slug" v-model="selectedTags" v-on:change="fetchFiles(true)">
						{{tag.name}}
					</label>
				</div>

				<button v-if="userCanWrite" class="btn btn-success" v-on:click="uploadFile">
					<i class="fa fa-upload"></i>
					Upload a File
				</button>
					
			</template>
			<template slot="main">

				<div class="d-flex justify-content-between flex-wrap">
					<h2>Files</h2>

					<search-bar
						style="width: 400px;"
						placeholder="Search files..."
						v-model="searchTerms"
						v-on:submit="filterFiles">
					</search-bar>
				</div>

				<file-list-item v-for="file in mutatedFiles"
					:key="file.id"
					:id="file.UploadFile.id"
					:tags="file.tags"
					:src="file.src"
					:thumb-src="file.thumbSrc"
					:label="file.UploadFile.original_filename"
					:size-kb="file.UploadFile.file_size_kb"
					:non-editable="!userCanWrite"
					:has-edit-button="true"
					:caption="file.caption"
					:uploaded-by="file.uploadedBy"
					:date-uploaded="file.created_at"
					:other-buttons="[{icon:'fa-check-square',text:'Acknowledge',titleText:'Acknowledge reading/receiving this file',action:'acknowledge'}]"
					v-on:editFile="editFile(file)"
					v-on:deleteFile="deleteFile(file)"
					v-on:acknowledge="acknowledgeFile(file)">
				</file-list-item>

				<p v-if="mutatedFiles.length == 0">No files found</p>
			</template>
		</collapsible-panel>

		<modal-dialog
			:modal-visible="uploadModal.visible"
			title="Upload New File"
			confirm-button-text="Save"
			v-on:closeModal="cancelUpload"
			v-on:confirm="saveFileDetails">

			<form-group label="File" col-class="col-md-4">
				<upload-field-with-panel
					api-model="LibraryUpload"
					upload-type="file"
					v-model="uploadModal.fileObj"
					v-on:uploaded="fileUploaded">
				</upload-field-with-panel>
			</form-group>

			<field label="Add a Caption"
				col-class="col-md-4"
				v-model="uploadModal.caption">
			</field>

			<field label="Tags"
				col-class="col-md-4"
				v-model="uploadModal.tags"
				:params="{type:'select-multi',options:tagsOptions}">
			</field>

			<!-- Blank access is uploader-only; this flag shares the file with the whole company. -->
			<field label="Make visible to everyone"
				col-class="col-md-4"
				v-model="uploadModal.is_visible_to_all"
				:params="{type:'boolean'}"
				:readonly="permsReadonly">
			</field>

			<!-- Company-wide files do not use a user list. -->
			<field v-if="uploadModal.is_visible_to_all != 1"
				label="Access Permissions"
				col-class="col-md-4"
				v-model="uploadModal.permissions"
				:params="{type:'select-multi',options:userOptions()}"
				:readonly="permsReadonly">
				<!-- Blank permissions are uploader-only; the toggle above is how a file is shared with the company. -->
				<div v-if="!permsReadonly" class="text-muted">Leaving permissions blank makes the file visible only to the uploader. Turn on Make visible to everyone to share it with any {{$store.company.company_name}} user.</div>
			</field>

			<field label="Expiry Date"
				col-class="col-md-4"
				v-model="uploadModal.expiry_date"
				:params="{type:'date'}">

				<div class="text-muted">Set a date for when the file should be renewed</div>
			</field>

			<field label="Acknowledgement Expiry Interval"
				col-class="col-md-4"
				v-model="uploadModal.acknowledgement_interval"
				:params="{type:'select',options:[
					{text: 'Never',value: ''},
					{text: '1 day', value: 'P1D'},
					{text: '2 days', value: 'P2D'},
					{text: '3 days', value: 'P3D'},
					{text: '4 days', value: 'P4D'},
					{text: '5 days', value: 'P5D'},
					{text: '6 days', value: 'P6D'},
					{text: '7 days', value: 'P7D'},
					{text: '14 days', value: 'P14D'},
					{text: '30 days', value: 'P30D'},
					{text: '1 month', value: 'P1M'},
					{text: '2 months', value: 'P2M'},
					{text: '3 months', value: 'P3M'},
					{text: '6 months', value: 'P6M'},
					{text: '1 year', value: 'P1Y'},
					{text: '2 years', value: 'P2Y'},
					{text: '3 years', value: 'P3Y'}
				]}">

				<div class="text-muted">Set an interval for when the document should be re-acknowledged by anyone who has acknowledged it initially</div>
			</field>

			<comment-thread
				:parent-slug="uploadModal.slug"
				:thread-id="'message_thread_id' in uploadModal ? uploadModal.message_thread_id : false"
				parent-model="LibraryFile"
				thread-subject-reference="Library File">
			</comment-thread>

		</modal-dialog>

		<modal-dialog
			:modal-visible="agreeModal.visible"
			title="Acknowledge"
			confirm-button-text="Agree"

			v-on:closeModal="agreeModal.visible = false"
			v-on:confirm="confirmAgree">

			<p class="text-muted" v-if="agreeModal.file && 'LibraryAcknowledgement' in agreeModal.file && agreeModal.file.LibraryAcknowledgement.length > 0">
				Last Acknowledged on {{formatDateTimeToLocal(agreeModal.file.LibraryAcknowledgement[0].acknowledgement_datetime)}}
			</p>

			<p v-if="agreeModal.file">
			By clicking "I agree", you ({{$store.userDetails.first_name}} {{$store.userDetails.last_name}}) acknowledge receiving and agree to abide by the contents contained within the file: <em>{{agreeModal.file.UploadFile.original_filename}}</em>
			</p>

			<div class="mt-4 text-center">
				<label>
					<input type="checkbox" required value="agree"> I agree
				</label>
			</div>

		</modal-dialog>

		<modal-dialog
			:modal-visible="deleteFileModal.visible"
			title="Delete File"
			confirm-button-text="Yes, Delete"
			button-class="btn-outline-danger"

			v-on:closeModal="deleteFileModal.visible = false"
			v-on:confirm="confirmDeleteFile">

			Delete this file?

		</modal-dialog>
	</div>
</template>
<script type="text/javascript">
import LibraryToolbar from "./LibraryToolbar"
import FileListItem from "@/components/FileListItem"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import PanelMenu from "@/components/PanelMenu"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import CommentThread from "@/components/super_components/CommentThread"

import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"
import FormGroup from "@/components/FormGroup"
import SearchBar from "@/components/SearchBar.vue"

export default {
	name: "LibraryList",
	components: {
		LibraryToolbar,
		FileListItem,
		UploadFieldWithPanel,
		CollapsiblePanel,
		ModalDialog,
		Field,
		PanelMenu,
		CommentThread,
		FormGroup,
		SearchBar
	},
	data() {
		return {
			allFiles: [],  // fetched
			files: [],     // filtered from allFiles
			tags: [],
			selectedTags: [],
			tagFilter: false,
			apiRoot: window.apiRoot,
			uploadModal: {
				filename: false,
				editing: false,
				visible: false,
				id: null,
				slug: null,
				caption: "",
				tags: [],
				fileId: null,
				created_by: null,
				permissions: [],
				// New uploads stay uploader-only until this is turned on.
				is_visible_to_all: 0,
				message_thread_id: null,
				expiry_date: null,
				acknowledgement_interval: null,
				fileChanged: false
			},
			deleteFileModal: {
				visible: false,
				file: null
			},
			agreeModal: {
				visible: false,
				acknowledgeText: "",
				file: null
			},
			fileIncludes: [
				"FileTag",
				{
					model: "LibraryAcknowledgement",
					filters: [["user_id",this.$store.userDetails.id]],
					limit: 1
				},
				{	
					model: "UploadFile",
					include: [{model:"User",fields: ["id","slug","first_name","last_name"]}]
				}
			],
			searchTerms: ""
		} 
	},
	computed: {
		userCanWrite() {
			if (this.getUserRoleType() == "Admin" || this.hasModulePermWrite("Library"))
				return true
			else
				return false
		},
		permsReadonly() {
			if (this.uploadModal.created_by == this.$store.userDetails.id || this.getUserRoleType() == "Admin" || this.hasModulePermWrite("Library"))
				return false

			else
				return true
		},
		mutatedFiles() {
			let vm = this

			return this.files.filter(file => file.UploadFile).map(file => {
				file.tags = file.FileTag.map(tag => {
					return tag.name
				})

				file.uploadedBy = file.UploadFile.UpdatedBy.first_name + " " + file.UploadFile.UpdatedBy.last_name

				file.thumbSrc = ""
				file.src = ""

				if (file.UploadFile.thumb_filename != "") {
					file.thumbSrc = vm.apiRoot + 'resources/images/' + vm.$store.sessionToken + '/' + file.UploadFile.thumb_filename
					file.src = vm.apiRoot + 'resources/images/' + vm.$store.sessionToken + '/' + file.UploadFile.thumb_filename
				}

				if (file.UploadFile.filename != "") {
					file.src = vm.apiRoot + 'resources/images/' + vm.$store.sessionToken + '/' + file.UploadFile.filename

					if (file.thumbSrc == "")
						file.thumbSrc = vm.apiRoot + 'resources/files/' + vm.$store.sessionToken + '/' + file.UploadFile.filename
				}

				return file
			})
		},
		tagsOptions() {
			return this.optionify(this.tags,"name")
		},
		tagMenu() {
			let vm = this

			let menuItems = [
				{text: "All",link: "/library/files"}
			]

			menuItems = menuItems.concat(vm.tags.map(tag => {
				return {
					text: tag.name,
					friendly_slug: tag.friendly_slug,
					link: "/library/files/"+tag.friendly_slug
				}
			}))

			return menuItems
		}
	},
	methods: {
		filterFiles() {

			if (!this.searchTerms || this.searchTerms.trim() == '')
				this.files = this.allFiles

			const terms = this.searchTerms.trim().toLowerCase()

			this.files = this.allFiles.filter(file => {

				// match one of the following:
				//   - caption
				//   - UploadFile.original_filename
				//   - UploadFile.UpdatedBy.first_name
				//   - UploadFile.UpdatedBy.last_name

				if ('caption' in file && file.caption && file.caption.toLowerCase().includes(terms))
					return true

				if ('UploadFile' in file && file.UploadFile) {

					if ('original_filename' in file.UploadFile && file.UploadFile.original_filename &&
						file.UploadFile.original_filename.toLowerCase().includes(terms))
						return true

					if ('UpdatedBy' in file.UploadFile && file.UploadFile.UpdatedBy) {

						if ('first_name' in file.UploadFile.UpdatedBy && file.UploadFile.UpdatedBy.first_name &&
							file.UploadFile.UpdatedBy.first_name.toLowerCase().includes(terms))
							return true

						if ('last_name' in file.UploadFile.UpdatedBy && file.UploadFile.UpdatedBy.last_name &&
							file.UploadFile.UpdatedBy.last_name.toLowerCase().includes(terms))
							return true
					}
				}

				return false
			})
		},
		resetUploadModal() {
			this.uploadModal.fileId = false
			this.uploadModal.caption = ""
			this.uploadModal.tags = []
			this.uploadModal.editing = false
			this.uploadModal.filename = false
			this.uploadModal.id = null
			this.uploadModal.created_by = this.$store.userDetails.id
			this.uploadModal.slug = null
			this.uploadModal.message_thread_id = null
			this.uploadModal.fileObj = null
			this.uploadModal.fileChanged = false
			this.uploadModal.expiry_date = null
			this.uploadModal.acknowledgement_interval = null
			// Next upload should not inherit the previous file's visibility.
			this.uploadModal.is_visible_to_all = 0
		},
		navigateToTag(item) {

			window.history.pushState({},"",item.link)

			if ("friendly_slug" in item)
				this.tagFilter = "/library/files/"+item.friendly_slug
			else
				this.tagFilter = "/library/files"

			this.fetchFiles()
		},
		cancelUpload() {
			this.uploadModal.visible = false

			if (this.uploadModal.fileId && !this.uploadModal.id) {
				//we have to delete the file quietly in the background so we don't clutter anything
				this.postData("LibraryUpload/delete",{id: this.uploadModal.fileId})
			}

			this.resetUploadModal()
		},
		uploadFile() {
			this.uploadModal.visible = true
			this.uploadModal.caption = ""
			this.uploadModal.tags = []
			this.uploadModal.fileObj = null
			this.uploadModal.editing = false
			// A new upload starts hidden from everyone except the uploader.
			this.uploadModal.is_visible_to_all = 0
		},
		fileUploaded(response) {
			let vm = this

			this.uploadModal.fileId = response.data.id
			this.uploadModal.filename = response.data.original_filename
			this.uploadModal.fileChanged = true
		},
		setUploadModal(record) {
			this.uploadModal.caption = record.caption
			this.uploadModal.id = record.id
			this.uploadModal.fileId = record.UploadFile.id
			this.uploadModal.filename = record.UploadFile.original_filename
			this.uploadModal.tags = this.primitize(record.FileTag)
			this.uploadModal.created_by = record.created_by
			this.uploadModal.slug = record.slug
			this.uploadModal.message_thread_id = record.message_thread_id
			this.uploadModal.fileObj = record.UploadFile
			this.uploadModal.expiry_date = record.expiry_date
			this.uploadModal.acknowledgement_interval = record.acknowledgement_interval
			// Keep the saved visibility flag on the form.
			this.uploadModal.is_visible_to_all = record.is_visible_to_all
			this.uploadModal.editing = true
			this.uploadModal.fileChanged = false

			try {
				this.uploadModal.permissions = JSON.parse(record.permissions_json)
			}
			catch (ex) {
				this.uploadModal.permissions = []
			}
		},
		editFile(file) 
		{
			this.uploadModal.editing = true
			this.uploadModal.visible = true
			this.setUploadModal(file)
		},
		deleteFile(file) {
			this.deleteFileModal.visible = true
			this.deleteFileModal.file = file
		},
		confirmDeleteFile() {
			let vm = this

			let promises = [
				this.postData("LibraryFile/delete",{id: this.deleteFileModal.file.id})
			]

			Promise.all(promises).then(responses => {
				if (responses[0].success) {
					vm.fetchFiles(false)
					vm.alertSuccess("File deleted")
				}
				else
					vm.alertFail("There was a problem deleting the file")

				vm.deleteFileModal.visible = false
				vm.deleteFileModal.file = null
			})
		},
		saveFileDetails() {
			let vm = this

			let payload = {}
			let saveMessage = ""

			if (this.uploadModal.editing) {
				payload = {
					id: this.uploadModal.id,
					caption: this.uploadModal.caption,
					permissions_json: JSON.stringify(this.uploadModal.permissions),
					// Persist the company-wide visibility toggle.
					is_visible_to_all: this.uploadModal.is_visible_to_all,
					expiry_date: this.uploadModal.expiry_date,
					acknowledgement_interval: this.uploadModal.acknowledgement_interval,
					FileTag: this.uploadModal.tags
				}

				if (this.uploadModal.fileChanged)
					payload.file_id = this.uploadModal.fileId

				saveMessage = "File details saved"
			}
			else if (this.uploadModal.fileId) {

				payload = {
					file_id: this.uploadModal.fileId,
					caption: this.uploadModal.caption,
					permissions_json: JSON.stringify(this.uploadModal.permissions),
					// Persist the company-wide visibility toggle.
					is_visible_to_all: this.uploadModal.is_visible_to_all,
					expiry_date: this.uploadModal.expiry_date,
					acknowledgement_interval: this.uploadModal.acknowledgement_interval,
					FileTag: this.uploadModal.tags
				}

				saveMessage = "File uploaded to library!"
	
			}
			else
				vm.alertFail("You need to upload an image!")


			if (Object.keys(payload).length > 0) {
				this.postData("LibraryFile/save", payload, true).then(response => {
					if (response.success) {
						vm.alertSaved(saveMessage)
						vm.fetchFiles()
						vm.uploadModal.visible = false
						vm.resetUploadModal()
					}
				})
			}
		},
		acknowledgeFile(file) {
			this.agreeModal.visible = true
			this.agreeModal.file = file
		},
		confirmAgree() {
			let vm = this

			let payload = {
				user_id: this.$store.userDetails.id,
				library_file_id: this.agreeModal.file.id,
				acknowledge_text: this.agreeModal.acknowledgeText
			}

			this.postData("LibraryAcknowledgement/save",payload,true).then(response => {
				vm.agreeModal.visible = false
				vm.fetchFiles()
			})
		},
		fetchFiles(spinner) {
			let vm = this

			let params = {
				include: this.cloneObj(this.fileIncludes)   // we may add a new include specifically for this api call
			}

			let friendly_slug = this.tagFilter.split("/").pop()

			let filters = []
			if (this.selectedTags.length > 0) {
				this.selectedTags.forEach(tagFriendlySlug => {
					filters.push(["FileTag.friendly_slug",tagFriendlySlug])
				})
			}

			params.filters = filters

			if (spinner)
				this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("LibraryFile/get",params,true).then(response => {

					if (spinner)
						vm.spinner(false)

					if (response.success) {
						vm.allFiles = response.data
						vm.filterFiles()
					}

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm  = this

			let tagParams = {
				filters: [
					["is_for_library",1]
				]
			}

			let promises = [
				this.fetchFiles(false),
				this.getJSON("FileTag/get",tagParams),
				this.fetchUsers([],false,["id","first_name","last_name","slug"])
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.tags = responses[1].data

				if (this.$route.name == 'LibraryListWithSlug' && "slug" in vm.$route.params) {
					//open model of specific file
					let file = vm.files.find(theFile => theFile.slug == vm.$route.params.slug)

					if ("view_type" in vm.$route.params && vm.$route.params.view_type == 'view') {
						this.searchTerms = file.UploadFile.original_filename

						this.filterFiles()
					}
					else {
						if (file) 
							vm.editFile(file)
					}
				}
			})
		}
	},
	created() {
		if ("tag" in this.$route.params)
			this.tagFilter = "/library/files/"+this.$route.params.tag
		else
			this.tagFilter = "/library/files"

		this.fetchData()
	}
}
</script>